import {
	getComponentMetadataRejected,
	getComponentMetadataResolved,
	getLoFComponentAssetMetadata,
	getLoFComponentInspectionMetadata,
	clearComponentMetadata,
	getCoFComponentAssetMetadata,
	getLoFComponentProximityMetadata,
	getCoFComponentProximityMetadata,
	getLoFComponentProximityAttrMetadata,
	getCoFComponentProximityAttrMetadata,
	getLoFComponentCustomTableMetadata,
	getCoFComponentCustomTableMetadata,
	getLoFComponentTaskMetadata,
	getCoFComponentTaskMetadata,
	getLoFComponentFailureDefinitionMetadata,
	getCoFComponentFailureDefinitionMetadata,
	getLoFComponentDeteriorationModelMetadata,
	getCoFComponentDeteriorationModelMetadata,
} from '@Actions';
import { createReducer } from '@reduxjs/toolkit';
import { ComponentMetadataStoreState } from '@Types';
import { AnyAction } from 'redux';

export const initState: ComponentMetadataStoreState = {
	isLoading: false,
	unique: undefined,
	precision: 0,
	range: undefined,
	unit: undefined,
};

interface ComponentReducer {
	[x: string]: (
		state: ComponentMetadataStoreState,
		action: AnyAction,
	) => ComponentMetadataStoreState | undefined;
}

// A metadata request clears the previous result and flags loading, so a
// failed request can't leave another component's metadata in the store.
const startMetadataLoad = (
	state: ComponentMetadataStoreState,
): ComponentMetadataStoreState => ({
	...state,
	unique: undefined,
	precision: 0,
	range: undefined,
	unit: undefined,
	currency: undefined,
	isLoading: true,
});

export const reducer: ComponentReducer = {
	[clearComponentMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: false,
	}),
	[getLoFComponentInspectionMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: true,
	}),
	[getLoFComponentAssetMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: true,
	}),
	[getCoFComponentAssetMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: true,
	}),
	[getLoFComponentProximityMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: true,
	}),
	[getCoFComponentProximityMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: true,
	}),
	[getLoFComponentProximityAttrMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: true,
	}),
	[getCoFComponentProximityAttrMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: true,
	}),
	[getLoFComponentCustomTableMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: true,
	}),
	[getCoFComponentCustomTableMetadata.toString()]: state => ({
		...state,
		unique: undefined,
		precision: 0,
		range: undefined,
		unit: undefined,
		currency: undefined,
		isLoading: true,
	}),
	[getLoFComponentTaskMetadata.toString()]: startMetadataLoad,
	[getCoFComponentTaskMetadata.toString()]: startMetadataLoad,
	[getLoFComponentFailureDefinitionMetadata.toString()]: startMetadataLoad,
	[getCoFComponentFailureDefinitionMetadata.toString()]: startMetadataLoad,
	[getLoFComponentDeteriorationModelMetadata.toString()]: startMetadataLoad,
	[getCoFComponentDeteriorationModelMetadata.toString()]: startMetadataLoad,
	[getComponentMetadataResolved.toString()]: (state, action) => {
		const payload = action.payload;
		if (action.payload.range) {
			const precision =
				action.payload.precision == undefined ||
				action.payload.precision == ''
					? 0
					: action.payload.precision;
			if (action.payload.range.max) {
				payload.range.max =
					Math.round(
						action.payload.range.max * Math.pow(10, precision),
					) / Math.pow(10, precision);
			}
			if (action.payload.range.min) {
				payload.range.min =
					Math.round(
						action.payload.range.min * Math.pow(10, precision),
					) / Math.pow(10, precision);
			}
		}
		return {
			...state,
			unique: payload.unique,
			precision: payload.precision,
			range: payload.range,
			unit: payload.unit,
			currency: payload.type == 'currency' ? payload.currency : undefined,
			isLoading: false,
		};
	},
	[getComponentMetadataRejected.toString()]: state => ({
		...state,
		isLoading: false,
	}),
};

export const componentReducer = createReducer(initState, reducer);
